<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">创作指令管理</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.instruct_name" placeholder="请输入指令名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增指令
        </el-button>
      </div>

      <!-- 指令列表 -->
      <el-table :data="instructionList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="instruct_name" label="指令名称" width="180" />
        <el-table-column prop="type_name" label="指令类型" width="120">
          <template #default="{ row }">
            <span :class="['type-tag', `type-${row.instruct_type}`]">
              {{ row.type_name }}
            </span>
          </template>
        </el-table-column>



        <el-table-column label="内容预览" min-width="200">
          <template #default="{ row }">
            <div class="content-preview">
              {{ row.content_preview }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="备注" width="150" />
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <el-table-column label="操作" width="180" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
              <el-icon>
                <Edit />
              </el-icon>
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchInstructions" @current-change="fetchInstructions" />
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
      <el-form ref="instructionForm" :model="instructionForm" label-width="120px" :rules="formRules">
        <el-form-item label="指令名称" prop="instruct_name">
          <el-input v-model="instructionForm.instruct_name" placeholder="请输入指令名称" size="large" />
        </el-form-item>

        <el-form-item label="指令类型" prop="instruct_type">
          <el-select v-model="instructionForm.instruct_type" placeholder="请选择类型" size="large">
            <el-option :value="1" label="文章创作" />
            <el-option :value="2" label="标题创作" />
            <el-option :value="3" label="小书创作" />
          </el-select>
        </el-form-item>

        <el-form-item label="指令内容" prop="instruct_content">
          <el-input v-model="instructionForm.instruct_content" type="textarea" :rows="6" placeholder="请输入详细的指令内容" />

          <!-- 新增模板填充按钮 -->
          <div class="template-buttons">
            <el-button type="primary" size="small" @click="fillTemplate(1)"
              :class="{ active: instructionForm.instruct_type === 1 }">
              填充文章模板
            </el-button>
            <el-button type="success" size="small" @click="fillTemplate(2)"
              :class="{ active: instructionForm.instruct_type === 2 }">
              填充标题模板
            </el-button>
            <el-button type="warning" size="small" @click="fillTemplate(3)"
              :class="{ active: instructionForm.instruct_type === 3 }">
              填充小书创作模板
            </el-button>
          </div>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="instructionForm.notes" placeholder="请输入备注信息" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitInstructionForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Edit, Delete
} from '@element-plus/icons-vue'

export default {
  name: 'SystemCommand',
  components: { Search, Plus, Edit, Delete },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增指令',
      isEditMode: false,
      searchForm: {
        instruct_name: ''
      },
      instructionForm: {
        id: null,
        instruct_name: '',
        instruct_type: 1,
        instruct_content: '',
        notes: ''
      },
      formRules: {
        instruct_name: [
          { required: true, message: '请输入指令名称', trigger: 'blur' }
        ],
        instruct_type: [
          { required: true, message: '请选择指令类型', trigger: 'change' }
        ],
        instruct_content: [
          { required: true, message: '请输入指令内容', trigger: 'blur' }
        ]
      },
      instructionList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.fetchInstructions();
  },
  methods: {

    // 填充模板内容（从接口获取）
    async fillTemplate(type) {
      try {
        // 更新指令类型（如果与当前选择不同）
        if (this.instructionForm.instruct_type !== type) {
          this.instructionForm.instruct_type = type;
        }

        // 显示加载状态
        const loadingInstance = this.$loading({
          lock: true,
          text: '正在加载模板...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 根据类型确定模板名称
        let templateName = '';
        switch (type) {
          case 1: // 文章创作
            templateName = 'content';
            break;
          case 2: // 标题创作
            templateName = 'title';
            break;
          case 3: // 小书创作
            templateName = 'greenbook';
            break;
        }

        // 从接口获取模板内容
        const { data } = await axios.get(
          `${config.BASE_URL}/shop/api/CreationInstructionsController.php`,
          {
            params: {
              template: templateName,
              t: Date.now() // 添加时间戳避免缓存
            },
            responseType: 'text' // 确保正确获取文本内容
          }
        );

        // 更新表单内容
        this.instructionForm.instruct_content = data;

        // 关闭加载状态
        loadingInstance.close();

        this.$message.success('模板加载成功！');
      } catch (error) {
        // 错误处理
        this.$message.error('模板加载失败: ' + (error.message || '请检查网络连接'));
        console.error('模板加载错误:', error);

        // 提供默认内容作为后备
        const defaultTemplates = {
          1: "请根据以下要求创作一篇高质量文章：\n\n1. 主题：{在此输入主题}\n2. 字数：800-1200字\n3. 结构：引言（吸引读者）- 主体（分3-5个论点）- 结论（总结升华）\n4. 风格：专业但不失生动，适当使用案例和数据支撑\n5. SEO优化：包含3-5个相关关键词\n\n请确保内容原创、有价值且符合主题要求。",
          2: "请为以下内容创作5-10个吸引人的标题：\n\n内容主题：{在此输入主题}\n目标平台：{公众号/知乎/头条等}\n\n要求：\n1. 长度不超过25字\n2. 包含数字或疑问句\n3. 激发读者好奇心\n4. 与目标平台风格匹配\n5. 避免夸张和误导性表述",
          3: "请创作一篇小红书风格的笔记：\n\n主题：{在此输入主题}\n要求：\n1. 包含吸引眼球的标题和封面文案\n2. 正文使用表情符号和分段短句（每段不超过3行）\n3. 添加相关话题标签（3-5个）\n4. 包含个人体验和真实感受\n5. 结尾有互动引导（如'大家觉得怎么样？'）\n\n风格：亲切自然，带点emoji，段落清晰"
        };

        this.instructionForm.instruct_content = defaultTemplates[type] || '请在此输入指令内容';
      }
    },
    // 获取指令列表
    async fetchInstructions() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.instruct_name ? 'search' : 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        if (this.searchForm.instruct_name) {
          params.instruct_name = this.searchForm.instruct_name;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/CreationInstructionsController.php`,
          params
        );

        if (data.data) {
          this.instructionList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取指令列表失败');
        console.error('获取指令列表错误:', error);
      } finally {
        this.loading = false;
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchInstructions();
    },

    // 打开新增对话框
    openAddDialog() {
      this.dialogTitle = '新增指令';
      this.isEditMode = false;
      this.instructionForm = {
        id: null,
        instruct_name: '',
        instruct_type: 1,
        instruct_content: '',
        notes: ''
      };
      this.dialogVisible = true;
    },

    // 打开编辑对话框
    openEditDialog(row) {
      this.dialogTitle = '编辑指令';
      this.isEditMode = true;
      this.instructionForm = {
        id: row.id,
        instruct_name: row.instruct_name,
        instruct_type: row.instruct_type,
        instruct_content: row.instruct_content,
        notes: row.notes
      };
      this.dialogVisible = true;
    },

    // 提交表单（新增/编辑）
    submitInstructionForm() {
      this.$refs.instructionForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const payload = {
              ...this.instructionForm,
              store_id: this.userInfo.id
            };

            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/CreationInstructionsController.php`,
              {
                action,
                ...payload
              }
            );

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchInstructions();
            }
          } catch (error) {
            this.$message.error('操作失败: ' + (error.response?.data?.error || error.message));
            console.error('表单提交错误:', error);
          }
        }
      });
    },

    // 删除指令
    async handleDelete(id) {
      this.$confirm('确定要删除该指令吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/CreationInstructionsController.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchInstructions();
          }
        } catch (error) {
          this.$message.error('删除失败: ' + (error.response?.data?.error || error.message));
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 20px;
}

.settings-form {
  max-width: 95%;
  margin: 0 auto;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.page-title {
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  :deep(.el-table__header) th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
  }

  :deep(.el-table__body) tr:hover>td {
    background-color: #f0f7ff !important;
  }
}

/* 操作按钮样式 */
.el-button {
  display: inline-flex;
  align-items: center;

  .el-icon {
    margin-right: 5px;
  }
}

/* 对话框样式优化 */
:deep(.el-dialog) {
  border-radius: 12px;

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #ebeef5;
    margin-right: 0;

    .el-dialog__title {
      font-weight: 600;
      color: #1f2937;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
  }
}

/* 新增特定样式 */
.el-select {
  width: 100%;
}

.el-textarea__inner {
  font-family: 'JetBrains Mono', monospace;
  line-height: 1.6;
}

/* 指令类型颜色 */
.type-tag {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.type-1 {
    /* 文章创作 */
    background-color: #e8f4ff;
    color: #409eff;
  }

  &.type-2 {
    /* 标题创作 */
    background-color: #f0f4ff;
    color: #668cff;
  }

  &.type-3 {
    /* 小书创作 */
    background-color: #e6f9f0;
    color: #34c759;
  }
}

/* 多行文本省略 */
.content-preview {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
  max-height: 3em;
  /* 2行 x 1.5行高 */
  word-break: break-all;
}

/* 调整表格单元格内边距 */
:deep(.el-table__body) td {
  padding: 12px 0;
}

:deep(.el-table__cell) {
  .cell {
    padding: 0 12px;
  }
}

/* 模板按钮样式 */
.template-buttons {
  margin-top: 10px;
  display: flex;
  gap: 10px;

  .el-button {
    flex: 1;
    transition: all 0.3s;

  }
}
</style>